import { t } from "@web-monorepo/i18n/macro";
import { getImageSrc } from "@web-monorepo/static-assets";
import { Radio, RadioChannel, sendRadio } from "src/pods/radio";
import { useToolkitRadioStore } from "src/pods/radio/toolkitRadioStore";
import { displayClose, displayOpen, remoteClose } from "src/pods/realtime";
import { useToolkitRealtimeStore } from "src/pods/realtime/toolkitRealtimeStore";
import { dispatchToolkitReduxAction } from "src/state/toolkitReduxStore";
import RadioRemote from "./RadioRemote";

const active = getImageSrc("toolkit/src/pods/radio/assets/active.svg");
const calm = getImageSrc("toolkit/src/pods/radio/assets/katie_reading.png");

type RadioRemoteContainerProps = {
  params: {
    classId: string;
    mountPoint: string;
  };
};

function getChannels() {
  const channels: RadioChannel[] = [
    {
      title: t`Focus`,
      icon: calm,
      tracks: Array.from({ length: 5 }, (_, n) => ({
        src: `https://static.classdojo.com/toolkit-static/radio/calm_${n + 1}.mp3`,
      })),
    },
    {
      title: t`Active`,
      icon: active,
      tracks: Array.from({ length: 5 }, (_, n) => ({
        src: `https://static.classdojo.com/toolkit-static/radio/upbeat_${n + 1}.mp3`,
      })),
    },
  ];
  return channels;
}

export default function RadioRemoteContainer({ params }: RadioRemoteContainerProps) {
  const radio = useToolkitRadioStore() as Radio;
  const { paired, displayOn } = useToolkitRealtimeStore();
  const isCasting = paired && displayOn;

  return (
    <RadioRemote
      {...radio}
      classId={params.classId}
      mountPoint={params.mountPoint}
      channels={getChannels()}
      isCasting={isCasting}
      displayOpen={(path, action) => dispatchToolkitReduxAction(displayOpen(path, action))}
      displayClose={() => dispatchToolkitReduxAction(displayClose())}
      remoteClose={() => dispatchToolkitReduxAction(remoteClose())}
      sendRadio={(payload) => dispatchToolkitReduxAction(sendRadio(payload))}
    />
  );
}
